module.exports = __webpack_public_path__ + "static/img/004_TO8_1464_og.e8592a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/004_TO8_1464_og.jpg
// module id = muii
// module chunks = 0